


































































/* General */

/* Mixins */
import SearchableDropdownMixin from '@/mixins/searchable-dropdown.mixin'

/* Components */

/* Helpers */
import AssigneeAssistant from '@/helpers/assignee-assistant'

/* Data types */
import { IPersonWithEmail } from '@/api/types/response.types'

/* API */

export default SearchableDropdownMixin.extend({
  name: 'IfpFilterAssignees',

  props: {
    assigneeOptions: {
      type: Array as () => IPersonWithEmail[],
      required: true,
    },
    assignedNotToYou: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      /* SearchableDropdownMixin configuration */
      allowMultipleSelections: true,
    }
  },

  computed: {
    totalOptionsCount(): number {
      return this.curatedAssigneeOptions.length
    },
    curatedAssigneeOptions(): IPersonWithEmail[] {
      return AssigneeAssistant.getFullAssigneeOptions(
        this.assigneeOptions,
        this.$permissions,
      )
    },
    filteredOptions(): IPersonWithEmail[] {
      if (this.filterQuery.length === 0) {
        return this.curatedAssigneeOptions
      }

      return this.curatedAssigneeOptions.filter(person => {
        return person.name
          .toLowerCase()
          .includes(this.filterQuery.toLowerCase())
      })
    },
    hasSelectedAssignees(): boolean {
      if (this.selectedIds.length === 0) {
        return false
      }

      return this.curatedAssigneeOptions.some(p =>
        this.selectedIds.includes(p.id),
      )
    },
    selectedAssignees(): IPersonWithEmail[] {
      return this.curatedAssigneeOptions.filter(p =>
        this.selectedIds.includes(p.id),
      )
    },
  },

  methods: {
    isAssigneeNotLoggedInUser(id: number) {
      return id !== this.$permissions.loggedInUser.id && id !== 0
    },
    toggleSelectedAssignee(id: number) {
      if (this.assignedNotToYou) {
        // If going from "All but you" to a selected assignee,
        // update both the 'assigned_not_to_you' boolean and the 'selectedIDs'
        // immediately to prevent a double call with the normal debounce
        this.handleSelection(id, true)
        this.updatedAssignedNotToYou(false)
      } else {
        this.handleSelection(id)
      }
    },
    updatedAssignedNotToYou(val: boolean) {
      this.$emit('assigned-not-to-you-updated', val)
    },
    handleClearClick() {
      this.clearSelectedIDs()
      this.updatedAssignedNotToYou(false)
    },
    handleAssignedNotToYouClick() {
      this.clearSelectedIDs()
      this.clearFilterQuery()
      this.updatedAssignedNotToYou(!this.assignedNotToYou)
    },
  },
})
